export default __webpack_public_path__ + "31012f9b3e3da44f87e842e419bc267a.woff";